export const app_token = `${process.env.REACT_APP_LEAN_TOKEN}`;
export const sandbox_status = `${process.env.REACT_APP_SANDBOX_STATUS}`;